export var RenderIndexMode;
(function (RenderIndexMode) {
    RenderIndexMode[RenderIndexMode["UNSIGNED_BYTE"] = 0] = "UNSIGNED_BYTE";
    RenderIndexMode[RenderIndexMode["UNSIGNED_SHORT"] = 1] = "UNSIGNED_SHORT";
    RenderIndexMode[RenderIndexMode["UNSIGNED_INT"] = 2] = "UNSIGNED_INT";
})(RenderIndexMode || (RenderIndexMode = {}));
